import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  InputAdornment,
} from '@material-ui/core';
import { CheckRounded, InfoRounded, LinkRounded, VpnKeyRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import CFARouter from 'components/Icons/CFARouter';
import theme from '../theme';
import { FormikTextFieldPx, useAuth, useToast,useMutation, useQuery } from '@webapps/reactjs-tech-components';
import { getOPCOsByCFA, addOPCOtoCFA } from '@webapps/business';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';

const {
  images: { 
    OpcoAfdas,
    OpcoAtlas,
    OpcoOcapiat,
    OpcoUniformation,
    OpcoConstructys,
    Opcommerce,
    OpcoAkto,
    Opco2i,
    OpcoMobilites,
    OpcoEp,
    OpcoSante, 
  },
} = theme;

const ModalOpco = ({
  onCancel,
  open,
}) => {
  const {
    css,
    cx,
    global,
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();
  const { idUser } = useAuth();

  const { data: opcos = {}, refetch } = useQuery(getOPCOsByCFA, {
    key: ['opco', idUser],
    variables: { id: idUser },
  });
  
  const {
      error,
      isSuccess,
      isError,
      mutateAsync: mutateAddOPCOtoCFA,
  } = useMutation(addOPCOtoCFA);

  const formik = useFormik({
    initialValues: {
      cfa: {
        id: idUser,
      },
      label: '',
      secretKey: '',
    },
    onSubmit: ({cfa, label, secretKey}) => {
      mutateAddOPCOtoCFA({
        data: {
          cfa,
          label,
          secretKey
        },
      });
    },
  });

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'OPCO ajouté avec succès',
        autoDismiss: true,
      });
      refetch();
      formik.resetForm();
    } else if (isError) {
      addToast({
        status: 'error',
        message: error.response.data.description || 'Erreur lors de l\'ajout de l\'OPCO',
        autoDismiss: true,
      });
      formik.resetForm();
    }
  }, [isSuccess, isError]);

  const handleClick = () => {
    window.open('https://www.cfadock.fr/portail_developpeur/doc/API%20Convergence%20-%20Mode%20Operatoire%20Recuperation%20CFA%20Key%20-%20v6.2.pdf', '_blank');
  };

  const handleSubmit = (opco) => {
    formik.setFieldValue('label', opco.label);
    formik.setFieldValue('secretKey', formik.values[`secretKey${opco.label}`]);
    formik.handleSubmit();
  };

  const getStatusChip = (opco) => {
    if(opco?.expirationDate){
      const expirationDate = new Date(opco.expirationDate);
      const currentDate = new Date();

      const isExpired = expirationDate < currentDate;
      const remainingDays = Math.ceil((expirationDate - currentDate) / (1000 * 60 * 60 * 24));

      if (isExpired) {
        return (
          <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
            className={classes.chip}
            color="primary"
            label={`Clé expirée`}
            size="small" 
          />
        )
      } else {
        return (
          <Chip classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
            className={classes.chip}
            color="primary"
            label={`Connexion établie (expire dans ${remainingDays} jours)`}
            size="small" 
          />
        )
      }
    } else if (!["Afdas", "Opco Mobilités", "Ocapiat"].includes(opco?.label)) {
      return (
        <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
          className={classes.chip}
          color="primary"
          label={'Opco non disponible'}
          size="small" 
        />
      )
    } else {
      return (
        <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
            className={classes.chip}
            color="primary"
            label={'Connexion non établie'}
            size="small" 
          />
      )
    }
  }

  const getLogo = (label) => {
    switch (label) {
      case 'Afdas':
        return OpcoAfdas;
      case 'Atlas':
        return OpcoAtlas;
      case 'Ocapiat':
        return OpcoOcapiat;
      case 'Uniformation':
        return OpcoUniformation;
      case 'Constructys':
        return OpcoConstructys;
      case 'Opcommerce':
        return Opcommerce;
      case 'Akto':
        return OpcoAkto;
      case 'Opco2i':
        return Opco2i;
      case 'Opco Mobilités':
        return OpcoMobilites;
      case 'Opco EP':
        return OpcoEp;
      case 'Opco Santé':
        return OpcoSante;
      default:
        return null;
    }
  };
    

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        paperScrollPaper: css({
          width: '100%',
          height: '100%',
          maxWidth: 'fit-content',
          borderRadius: 20,
          position: 'relative',
          overflow: 'visible',
        }),
      }}
      onClose={() => onCancel("1")}
      open={open}
    >
      <div className={classes.container}>
        <div className={classes.leftpan}>
          <CFARouter className={classes.image} />
          <div className={classes.title}>Synchroniser les dossiers avec les 11 OPCOs</div>
          <div className={classes.subTitle}>Lorem ipsum</div>
          <div>
            <div className={classes.listTitle}>Processus de synchronisation :</div>
            <ul className={classes.ul}>
              <li className={classes.li}>Synchroniser les dossiers avec les OPCOs</li>
              <li className={classes.li}>Envoyer les dossiers à l'OPCO</li>
              <li className={classes.li}>Recevoir les dossiers de l'OPCO</li>
              <li className={classes.li}>Traiter les dossiers de l'OPCO</li>
            </ul>
          </div>
          <Button className={global.buttonCFADashboard} onClick={handleClick}>
            <div className={cx(global.buttonCFADashboardText, classes.button)}><LinkRounded className={classes.icon} /> <div className={classes.buttonText}>Mode Opératoire de récupération de la clé API</div></div>
          </Button>
          <div className={classes.alert}>
            <div className={cx(classes.alertText, classes.button)}> <InfoRounded /> Je suis une altere de niveau critique</div>
          </div>
        </div>
        <div className={classes.rightpan}>
          {opcos?.length > 0 && opcos?.map((opco) => (
            <div className={classes.row}>
              <div className={cx(global.frac, css({ gap: "20px" }))}>
                <img alt={opco.label} className={classes.logo} src={getLogo(opco.label)} />
                <div className={classes.opcoTitle}>{opco.label}</div>
              </div>
              <div className={cx(global.frac, css({ gap: "10px" }))}>
                <div className={global.formikTextField}>
                  <FormikTextFieldPx
                    formik={formik}
                    borderRadius={10}
                    type="password"
                    variant="outlined"
                    name={`secretKey${opco.label}`}
                    value={formik.values[`secretKey${opco.label}`] || ''}
                    placeholder="************************"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <VpnKeyRounded style={{ color: '#92ABD2' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <Button className={cx(global.greyButton, classes.checkButton)} variant="outlined" onClick={() => handleSubmit(opco)}>
                  <CheckRounded />
                </Button>
                {getStatusChip(opco)}
              </div>
            </div>
            ))
          }
        </div>
      </div>
    </Dialog>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    height: "100%",
  },
  leftpan: {
    backgroundColor: '#F3F7FF',
    borderBottomLeftRadius: '20px',
    borderTopLeftRadius: '20px',
    padding: "48px",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    flexWrap: "nowrap",
    width: "min-content",
  },
  rightpan: {
    backgroundColor: 'white',
    borderBottomRightRadius: '20px',
    borderTopRightRadius: '20px',
    padding: "48px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flexWrap: "nowrap",
    width: "834px",
    overflowX: "auto",
  },
  title: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '30px',
    color: '#152652',
  },
  subTitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    color: '#152652',
  },
  listTitle: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '14px',
    color: '#152652',
  },
  ul: {
    listStyle: 'none',
    marginBottom: 0,
    marginTop: 20,
    paddingLeft: 0,
    color: "#5D75A8",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  li: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '14px',
    lineHeight: '14px',
    position: 'relative',
    paddingLeft: '20px',
    '::before': {
        content: '"•"',
        position: 'absolute',
        left: 0,
        top: 0,
        fontSize: '16px',
        color: '#5D75A8',
        lineHeight: '14px',
      },
  },
  button: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  buttonText: {
    fontSize: "13.5px",
    fontWeight: 500,
    whiteSpace: "pre",
  },
  checkButton: {
    borderRadius: 6,
    padding: 0,
    minWidth: 40,
  },
  icon: {
    fontSize: 18,
  },
  image: {
    width: '120px',
  },
  alert: {
    backgroundColor: "#FBD3D5",
    padding: 10,
    borderRadius: "6px",
  },
  alertText: {
    color: "#F50057",
    fontSize: "12px",
  },
  logo: {
    width: '40px',
  },
  opcoTitle: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '14px',
    color: '#152652',
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  chip: {
    height: 40,
    width: "270px",
    padding: "0px!important",
  }
});

export default ModalOpco;
